import type React from "react";
import { ReactComponent as Svg } from "./assets/face-id.svg";
import * as styles from "./Icon.module.scss";

type FaceIdProps = React.SVGProps<SVGSVGElement>;

export const FaceId = ({ className, ...props }: FaceIdProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
